import { ModalWithTransition, Figure } from '@studiometa/ui';
/**
 * Modal Media
 */
export default class ModalMedia extends ModalWithTransition {
  static config = {
    name: 'App',
    components: {
      Figure,
    },
  };

  /**
   * Open modal
   * @param {string} content New modal content
   * @returns {Function}
   */
  open(content) {
    this.$refs.content.innerHTML = content;
    this.$update();
    return super.open();
  }

  /**
   * Close modal
   * @returns {Function}
   */
  close() {
    this.$refs.content.innerHTML = '';
    this.$update();
    return super.close();
  }
}
